import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { StackingAlertBanner } from '@saviynt/design-system';

import { setCertsExportStatus } from '../../../redux/certdetails/action';
import { getMessageKey } from '../../../utils/utils';

function CertsDetailsExportAlerts() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [alertStatus, setAlertStatus] = useState('');

  const { certsExportStatus } = useSelector(
    (state) => state?.certifications?.details?.certsExport || {}
  );

  const { messages } = useSelector((state) => state?.user);

  useEffect(() => {
    const currentExportStatus = certsExportStatus?.exportStatus;

    switch (currentExportStatus) {
      case 'SUCCESS':
      case 'FAILED-412':
        setAlertStatus(currentExportStatus);
        break;
      default:
        setAlertStatus('');
        break;
    }
  }, [certsExportStatus]);

  const alertConfigs = {
    SUCCESS: {
      colorTheme: 'Information',
      title:
        messages.EXPORT_ALERT_SUCCESS_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_SUCCESS_TITLE')),
      description:
        messages['EXPORT_ALERT_SUCCESS_DESCRIPION.ATTESTATIONS'] ||
        localize(
          intl,
          getMessageKey('EXPORT_ALERT_SUCCESS_DESCRIPION.ATTESTATIONS')
        ),
    },
    FAILED: {
      colorTheme: 'Critical',
      title:
        messages.EXPORT_ALERT_FAILED_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_FAILED_TITLE')),
      description:
        messages['EXPORT_ALERT_FAILED_DESCRIPION.ATTESTATIONS'] ||
        localize(
          intl,
          getMessageKey('EXPORT_ALERT_FAILED_DESCRIPION.ATTESTATIONS')
        ),
    },
    'FAILED-412': {
      colorTheme: 'Information',
      title:
        messages.EXPORT_ALERT_FAILED412_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_FAILED412_TITLE')),
      description:
        messages['EXPORT_ALERT_FAILED412_DESCRIPTION.ATTESTATIONS'] ||
        localize(
          intl,
          getMessageKey('EXPORT_ALERT_FAILED412_DESCRIPTION.ATTESTATIONS')
        ),
    },
  };

  const config = alertConfigs[alertStatus];

  return config ? (
    <StackingAlertBanner
      colorTheme={config.colorTheme}
      title={config.title}
      description={config.description}
      isVisible={Boolean(alertStatus)}
      kind='low'
      onCancel={() => {
        setAlertStatus('');
        dispatch(
          setCertsExportStatus({
            exportStatus: '',
            timeStamp: 0,
          })
        );
      }}
      shouldAutoDismiss
    />
  ) : null;
}

export default CertsDetailsExportAlerts;
